export const HomeRouteLink = () => "/";
export const LoginRouteLink = () => "/login";
export const AboutRouteLink = () => "/about";
export const SubmitOpportunityRouteLink = () => "https://hpanel.opportunitesjeunes.ci/admin/content-manager/collectionType/api::opportunity.opportunity/create";
export const NotFoundRouteLink = () => "*"; // This is a catch-all router that will match any path that is not matched by the other routes.
